<template>
  <TablaDatosAPI
      tabla="v_regeve"
      v-bind="$attrs"
    >
      <template v-slot:[`item.fechor__VT`]="{ item }">
        <span style="white-space: nowrap">
          {{item.fechor__VT}}
        </span>
      </template>

      <template v-slot:[`item.id_apa__VT`]="{ item }">
        <span style="white-space: nowrap">
          <span      v-if="item.id_tipapa == 4"><v-icon color="#cfaf50" class="mr-1">mdi-circle-double</v-icon></span>
          <span v-else-if="item.id_tipapa == 5"><v-icon color="#659567" class="mr-1">mdi-location-enter</v-icon></span>
          <span v-else-if="item.id_tipapa == 6"><v-icon color="#50779f" class="mr-1">mdi-location-exit mdi-flip-h</v-icon></span>
          <span v-else-if="item.id_tipapa == 7"><v-icon color="#cfaf50" class="mr-1">mdi-chevron-right-circle-outline</v-icon></span>
          <span v-else-if="item.id_tipapa == 8"><v-icon color="#9f5077" class="mr-1">mdi-swap-horizontal-circle-outline</v-icon></span>
          <span v-else-if="item.id_tipapa == 9 && item.id_modapa == 91"><v-icon color="#9f5077" class="mr-1">mdi-door-closed-lock</v-icon></span>
          <span v-else-if="item.id_tipapa == 9 && [92, 93].includes (item.id_modapa)"><v-icon color="#a88a99" class="mr-1">mdi-circle-box-outline</v-icon></span>
          {{item.id_apa__VT}}
        </span>
      </template>

      <template v-slot:[`item.id_tipeve__VT`]="{ item }">
        <span style="white-space: nowrap">
          <v-icon v-if="item.id_tipeve == 10" color="#9f5077" class="mr-1">mdi-walk</v-icon>
          <v-icon v-else-if="item.id_tipeve == 15" color="#659567" class="mr-1">mdi-arrow-right-bold</v-icon>
          <v-icon v-else-if="item.id_tipeve == 16" color="#50779f" class="mr-1">mdi-arrow-left-bold</v-icon>
          <v-icon v-else-if="item.id_tipeve == 20" color="#df5349" class="mr-1">mdi-alert-circle</v-icon>
          <v-icon v-else-if="item.id_tipeve == 30" color="#5C6BC0" class="mr-1">mdi-playlist-edit</v-icon>
          <v-icon v-else-if="item.id_tipeve == 40" color="#4DB6AC" class="mr-1">mdi-cash</v-icon>
          <v-icon v-else-if="item.id_tipeve == 41" color="#80b380" class="mr-1">mdi-circle-multiple</v-icon>
          <!-- <v-icon v-else color="#f39800" class="mr-1">mdi-alert</v-icon> -->
          {{ item.id_tipeve__VT }}
        </span>
      </template>

      <template v-slot:[`item.matrec`]="{ item }">
        <template v-if="item.matrec">
          <span class="matricula">{{ item.matrec }}</span>
        </template>
      </template>

    </TablaDatosAPI>
</template>

<script>
import TablaDatosAPI from "@/components/TablaDatosAPI.vue";

export default {
  components: { TablaDatosAPI },
  methods: {
    descripcionDatosAdicionales (json_datadi) {
      let datadi = JSON.parse (json_datadi);
      if (!datadi)
        return '';
      let r = [];
      if (datadi.des) r.push (datadi.des);
      if (datadi.ope) r.push (`(Operador: ${datadi.ope})`);

      // return JSON.stringify (datadi);
      return r.join (' ');
    }
  }
}
</script>

<style>

</style>